import { AnyRecord } from './createRoutineSlice.types';

/**
 * @param nodeSelector Selector to the object containing `prop`
 * @param prop Property, existing on `parentSelector`'s return value
 * @returns a new selector: `state => nodeSelector(state)?.[prop]`
 */
function getPropSelector<
    RootState extends AnyRecord,
    NodeSelectorStatePart extends AnyRecord,
    Prop extends keyof NodeSelectorStatePart,
>(nodeSelector: (state: RootState) => NodeSelectorStatePart, prop: Prop) {
    return (state: RootState): NodeSelectorStatePart[Prop] => nodeSelector(state)?.[prop];
}

const defaultArrayAsObjCallback = (entity: AnyRecord) => [entity.id, entity];

/**
 * @param arr array of objects having string- or number-value key `id`
 */
function arrayAsObject<A extends { id: string | number }>(arr: A[]): Record<A['id'], A>;

/**
 * @param arr array of objects
 * @param callback function accepting array item as argument and returns `[key, value]` pair of the target object
 */
function arrayAsObject<A extends AnyRecord, K extends string | number, V>(
    arr: A[],
    callback: (item: A) => [K, V],
): Record<K, V>;

function arrayAsObject(arr: AnyRecord[], callback = defaultArrayAsObjCallback) {
    return arr.reduce((acc, item) => {
        const [key, val] = callback(item);
        acc[key] = val;
        return acc;
    }, {} as AnyRecord);
}

export { getPropSelector, arrayAsObject };
